<div class="wrapper flex flex-col gap-[40px]">
  <section class="header-section flex flex-row justify-between items-start w-[711px]">
    <div class="header-left-section flex flex-row gap-[20px]">
      <app-image
        alt="{{ siteDetails?.name }}_picture"
        class="project-image"
        url="{{siteDetails?.imageUrl}}"
      />
      <div class="heading-section">
        <div #siteHeading
          class="heading text-type-2"
          [matTooltip]="siteDetails?.name"
          [matTooltipDisabled]="!headingEllipsis"
          matTooltipPosition="above"
          matTooltipClass="project-name-tooltip">{{ siteDetails?.name }}
        </div>
        <div #siteSubHeading
          class="sub-heading text-type-10"
          [matTooltip]="siteDetails?.project?.name + ', ' + siteDetails?.project?.owner"
          [matTooltipDisabled]="!subHeadingEllipsis"
          matTooltipPosition="below"
          matTooltipClass="project-name-tooltip">
          <span class="project-link" (click)="navigateToProject()">{{ siteDetails?.project?.name }}</span>, {{ siteDetails?.project?.owner }}
        </div>
      </div>
    </div>
    <div class="header-right-section action-section">
    </div>
  </section>
  <section class="content-section">
    <mat-tab-group
      #tabGroup
      [selectedIndex]="selectedTabIndex"
      class="contents-tab-group"
    >
      <mat-tab label="Daily report">
        <app-daily-report-wrapper />
      </mat-tab>
      <mat-tab label="Workflow">
        <app-changes-wrapper />
      </mat-tab>
    </mat-tab-group>
  </section>
</div>
